/*
  Fade-and-rise on scroll.

  The .js class goes on before first paint so the hidden state in base.css only
  ever applies when this file is actually running. Without it — scripting off,
  or the script blocked — content renders visible instead of stranded at zero
  opacity.
*/
document.documentElement.classList.add('js');

document.addEventListener('DOMContentLoaded', function () {
  var targets = document.querySelectorAll('.reveal');
  if (!targets.length) return;

  if (typeof IntersectionObserver === 'undefined') {
    targets.forEach(function (el) {
      el.dataset.shown = 'true';
    });
    return;
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.dataset.shown = 'true';
        observer.unobserve(entry.target);
      });
    },
    { rootMargin: '0px 0px -12% 0px', threshold: 0.05 }
  );

  targets.forEach(function (el) {
    observer.observe(el);
  });
});
